import React from 'react'
import { StyledForm } from './Styles'

const Form = ({ children, formParams = { handleSubmit: () => { }, onSubmit: () => { } } }) => {

	return (
		<StyledForm onSubmit={formParams.handleSubmit(formParams.onSubmit)}>
			{Array.isArray(children)
				? children.map((child) => {
					return child.props.name
						? React.createElement(child.type, {
							...{
								...child.props,
								register: formParams.register,
								key: child.props.name
							}
						})
						: child;
				})
				: children}
		</StyledForm>
	)
}

export default Form